var map = {
	"./Inter": [
		"7deb"
	],
	"./Inter/": [
		"7deb"
	],
	"./Inter/Inter-Bold-normal": [
		"6008"
	],
	"./Inter/Inter-Bold-normal.js": [
		"6008"
	],
	"./Inter/Inter-ExtraBold-normal": [
		"6a54"
	],
	"./Inter/Inter-ExtraBold-normal.js": [
		"6a54"
	],
	"./Inter/Inter-Medium-normal": [
		"87b9"
	],
	"./Inter/Inter-Medium-normal.js": [
		"87b9"
	],
	"./Inter/Inter-SemiBold-normal": [
		"cef0"
	],
	"./Inter/Inter-SemiBold-normal.js": [
		"cef0"
	],
	"./Inter/index": [
		"7deb"
	],
	"./Inter/index.ts": [
		"7deb"
	],
	"./Montserrat": [
		"1451"
	],
	"./Montserrat/": [
		"1451"
	],
	"./Montserrat/Montserrat-Bold-italic": [
		"8329"
	],
	"./Montserrat/Montserrat-Bold-italic.js": [
		"8329"
	],
	"./Montserrat/Montserrat-Bold-normal": [
		"335a"
	],
	"./Montserrat/Montserrat-Bold-normal.js": [
		"335a"
	],
	"./Montserrat/Montserrat-ExtraBold-normal": [
		"f900"
	],
	"./Montserrat/Montserrat-ExtraBold-normal.js": [
		"f900"
	],
	"./Montserrat/Montserrat-Medium-normal": [
		"ba72"
	],
	"./Montserrat/Montserrat-Medium-normal.js": [
		"ba72"
	],
	"./Montserrat/Montserrat-Regular-normal": [
		"3b5f"
	],
	"./Montserrat/Montserrat-Regular-normal.js": [
		"3b5f"
	],
	"./Montserrat/Montserrat-SemiBold-normal": [
		"a093"
	],
	"./Montserrat/Montserrat-SemiBold-normal.js": [
		"a093"
	],
	"./Montserrat/index": [
		"1451"
	],
	"./Montserrat/index.ts": [
		"1451"
	],
	"./Poppins": [
		"b7a9"
	],
	"./Poppins/": [
		"b7a9"
	],
	"./Poppins/Poppins-Bold": [
		"f634"
	],
	"./Poppins/Poppins-Bold.js": [
		"f634"
	],
	"./Poppins/Poppins-Medium": [
		"6752"
	],
	"./Poppins/Poppins-Medium.js": [
		"6752"
	],
	"./Poppins/Poppins-Regular": [
		"52cc"
	],
	"./Poppins/Poppins-Regular.js": [
		"52cc"
	],
	"./Poppins/Poppins-SemiBold": [
		"5d8c"
	],
	"./Poppins/Poppins-SemiBold.js": [
		"5d8c"
	],
	"./Poppins/index": [
		"b7a9"
	],
	"./Poppins/index.ts": [
		"b7a9"
	],
	"./RobotoMono": [
		"acbd"
	],
	"./RobotoMono/": [
		"acbd"
	],
	"./RobotoMono/RobotoMono-Bold-normal": [
		"3584"
	],
	"./RobotoMono/RobotoMono-Bold-normal.js": [
		"3584"
	],
	"./RobotoMono/RobotoMono-Medium-normal": [
		"9fa1"
	],
	"./RobotoMono/RobotoMono-Medium-normal.js": [
		"9fa1"
	],
	"./RobotoMono/RobotoMono-SemiBold-normal": [
		"cc50"
	],
	"./RobotoMono/RobotoMono-SemiBold-normal.js": [
		"cc50"
	],
	"./RobotoMono/index": [
		"acbd"
	],
	"./RobotoMono/index.ts": [
		"acbd"
	],
	"./arabic": [
		"aad9",
		"chunk-38f40cc0"
	],
	"./arabic.ts": [
		"aad9",
		"chunk-38f40cc0"
	],
	"./bengali": [
		"fcb3",
		"chunk-7a030747"
	],
	"./bengali.ts": [
		"fcb3",
		"chunk-7a030747"
	],
	"./cambodian": [
		"28f3",
		"chunk-863a42bc"
	],
	"./cambodian.ts": [
		"28f3",
		"chunk-863a42bc"
	],
	"./chinese": [
		"462c",
		"chunk-ae6410fc"
	],
	"./chinese.ts": [
		"462c",
		"chunk-ae6410fc"
	],
	"./gujarati": [
		"f395",
		"chunk-eb565d68"
	],
	"./gujarati.ts": [
		"f395",
		"chunk-eb565d68"
	],
	"./japanese": [
		"e7c7",
		"chunk-46c47faf"
	],
	"./japanese.ts": [
		"e7c7",
		"chunk-46c47faf"
	],
	"./korean": [
		"5e86",
		"chunk-4004f307"
	],
	"./korean.ts": [
		"5e86",
		"chunk-4004f307"
	],
	"./module": [
		"b592",
		"chunk-2d20fb62"
	],
	"./module/": [
		"b592",
		"chunk-2d20fb62"
	],
	"./module/index": [
		"b592",
		"chunk-2d20fb62"
	],
	"./module/index.ts": [
		"b592",
		"chunk-2d20fb62"
	],
	"./nepali": [
		"7a22",
		"chunk-03d3fd87"
	],
	"./nepali.ts": [
		"7a22",
		"chunk-03d3fd87"
	],
	"./notosans": [
		"b2e6",
		"chunk-03e6df3e"
	],
	"./notosans.ts": [
		"b2e6",
		"chunk-03e6df3e"
	],
	"./punjabi": [
		"9d66",
		"chunk-03d4f208"
	],
	"./punjabi.ts": [
		"9d66",
		"chunk-03d4f208"
	],
	"./sinhala": [
		"823b",
		"chunk-03d3c1c6"
	],
	"./sinhala.ts": [
		"823b",
		"chunk-03d3c1c6"
	],
	"./tamil": [
		"c328",
		"chunk-03e75133"
	],
	"./tamil.ts": [
		"c328",
		"chunk-03e75133"
	],
	"./telugu": [
		"ad04",
		"chunk-03e72024"
	],
	"./telugu.ts": [
		"ad04",
		"chunk-03e72024"
	],
	"./thai": [
		"e9d5",
		"chunk-03e85682"
	],
	"./thai.ts": [
		"e9d5",
		"chunk-03e85682"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cfbd6";
module.exports = webpackAsyncContext;